import { useEffect, useState } from 'react';
import { getSettings } from '../services/api';

const DEFAULTS = {
  email: 'hello@camption.com',
  phone: '0 (850) 495 95 24',
  whatsapp: '908504959524',
  address: 'Antalya, Türkiye',
  hoursWeekday: '09:00 - 18:00',
  hoursSaturday: '10:00 - 16:00',
  hoursSunday: 'Sadece WhatsApp',
  instagram: '',
  twitter: '',
  facebook: '',
  youtube: '',
};

// Module-level cache so multiple components don't refetch on every mount.
let _cache = null;
let _inflight = null;

/**
 * Hook to read public site settings (email, phone, address, social links).
 * Falls back to sensible defaults if API is unreachable.
 */
export const useSiteSettings = () => {
  const [data, setData] = useState(_cache || DEFAULTS);

  useEffect(() => {
    if (_cache) return;
    if (!_inflight) _inflight = getSettings().then(r => r.data).catch(() => DEFAULTS);
    _inflight.then(s => {
      _cache = { ...DEFAULTS, ...(s || {}) };
      setData(_cache);
    });
  }, []);

  return data;
};
